import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/tailwind.css';
import './styles/tokens.css';
import './styles/app.css';
import i18n from './i18n';
import { applyBrand } from './brand';
import App from './App';
import { registerServiceWorker } from '@coeldery/pwa-spa';

/** 品牌（色／標題）由 `brand.json` 出 —— 喺 render 之前套一次（`decisions/010` Phase A） */
applyBrand(i18n.language);

const container = document.getElementById('root');
if (!container) {
  throw new Error('#root not found — index.html 有問題');
}

/** PWA：只喺生產 build 註冊 SW（dev 註冊會 cache 住舊 asset，令 HMR 鬼打牆） */
registerServiceWorker({ enabled: import.meta.env.PROD });

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);

